// Actions
const OPEN = "hermes/edit-dialog/OPEN";
const CLOSE = "hermes/edit-dialog/CLOSE";
const HYDRATE_DIALOG_REFERRAL = "hermes/edit-dialog/HYDRATE_DIALOG_REFERRAL";

const initialState = {
  dialogOpen: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPEN:
      return {
        ...state,
        dialogOpen: true,
        dialogReferral: action.dialogReferral,
        dialogAction: action.dialogAction,
      };
    case CLOSE:
      return {
        ...state,
        dialogOpen: false,
        dialogReferral: undefined,
        dialogAction: undefined,
        formValues: undefined,
      };
    case HYDRATE_DIALOG_REFERRAL:
      return {
        ...state,
        dialogReferral: action.referral,
      };
    default:
      return state;
  }
}

// Action Creators
export function openDialog(referral, action) {
  return { type: OPEN, dialogReferral: referral, dialogAction: action };
}

export function closeDialog() {
  return { type: CLOSE };
}

export function hydrateDialogReferral(referral) {
  return {
    type: HYDRATE_DIALOG_REFERRAL,
    referral,
  };
}
